import React, { useState } from 'react';
import { injectIntl, intlShape, FormattedMessage } from '../../util/reactIntl';
import { Field } from 'react-final-form';
import { IconSpinner } from '../../components';

import classNames from 'classnames';
import css from './FieldFileUploader.module.css';

const VALID_FILE_FORMATS = [
  'application/zip',
  'application/x-zip-compressed',
  'application/x-rar-compressed',
  'application/vnd.rar',
  'application/x-7z-compressed',
  'application/x-bzip2',
  'application/x-tar',
  'application/gzip',
  'application/x-gzip',
  'image/jpeg',
  'image/jpg',
  'image/tiff',
  'image/png',
  'jpeg',
  'jpg',
  'tiff',
  'png',
  'mp4',
  'video/mp4',
  'video/webm',
  'webm',
];

const MAX_FILE_SIZE = 5000000000;
const MAX_FILE_LENGTH = 200;

const IconUploadFile = () => {
  return (
    <svg
      className={css.sendIcon}
      width="14px"
      height="14px"
      viewBox="0 -2 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Page-1" stroke="none" fill="none">
        <g id="Icon-Set" transform="translate(-569.000000, -674.000000)" fill="#000000">
          <path
            d="M579.732,681.7 L583,677.74 L583,691.998 C583,692.552 583.447,693 584,693 C584.553,693 585,692.552 585,691.998 L585,677.702 L588.299,681.7 C588.69,682.095 589.326,682.095 589.719,681.7 C590.11,681.307 590.11,680.668 589.719,680.274 L584.776,674.283 C584.566,674.073 584.289,673.983 584.016,673.998 C583.742,673.983 583.465,674.073 583.256,674.283 L578.313,680.274 C577.921,680.668 577.921,681.307 578.313,681.7 C578.705,682.095 579.341,682.095 579.732,681.7 L579.732,681.7 Z M598,690 C597.447,690 597,690.448 597,691 L597,698 L571,698 L571,691 C571,690.448 570.553,690 570,690 C569.447,690 569,690.448 569,691 L569,699 C569,699.553 569.447,700 570,700 L598,700 C598.553,700 599,699.553 599,699 L599,691 C599,690.448 598.553,690 598,690 L598,690 Z"
            id="upload"
          ></path>
        </g>
      </g>
    </svg>
  );
};

const FieldFileUploader = props => {
  const {
    isProvider,
    uploadFileInProgress,
    intl,
    onUploadFilesTx,
    onDeleteFileTx,
    id,
    entity,
    accept,
    files,
    isArchive,
    deleteOldFilesAfterUpload,
  } = props;

  const [validationError, setValidationError] = useState(null);

  return (
    <Field form={null} name="files" type="file" multiple>
      {fieldprops => {
        const { input } = fieldprops;
        const { name, type } = input;
        const userRole = isProvider ? 'provider' : 'customer';
        const onChange = async e => {
          if (uploadFileInProgress || !e.target.files[0]) return;

          const file = e.target.files;
          const uploadedFiles = [...e.target.files];

          const allFiles =  [...uploadedFiles, ...files];

          const invalidFilesLength = allFiles?.length > MAX_FILE_LENGTH;
          const invalidFormat = !!uploadedFiles.filter(f => !VALID_FILE_FORMATS.includes(f.type))
            ?.length;
          const invalidSize = !!uploadedFiles.filter(f => f.size > MAX_FILE_SIZE)?.length;

          invalidFilesLength &&
            setValidationError(
              <FormattedMessage
                id="SendMessageForm.invalidLength"
                values={{ maxLength: MAX_FILE_LENGTH }}
              />
            );

          invalidFormat &&
            setValidationError(
              <FormattedMessage
                id="SendMessageForm.invalidFormat"
                values={{ validFormats: accept }}
              />
            );

          invalidSize &&
            setValidationError(
              <FormattedMessage
                id="SendMessageForm.invalidSize"
                values={{ maxSize: MAX_FILE_SIZE / 1000000000 }}
              />
            );

          if (id && !invalidFormat && !invalidSize && !invalidFilesLength) {
            try {
              // if (files?.length && deleteOldFilesAfterUpload) {
              //   await Promise.all(files.map(f => onDeleteFileTx(f.key, id, 'tx')));
              // }

              onUploadFilesTx(file, id, userRole, entity, 'files');
              setValidationError(null);
              e.target.value = '';
            } catch (error) {
              console.error('Error during file deletion or upload:', error);
              setValidationError(<FormattedMessage id="SendMessageForm.uploadError" />);
            }
          }
        };

        const inputProps = { accept, id: name, name, onChange, type, multiple: true };

        return (
          <div className={css.root}>
            <input {...inputProps} className={css.addImageInput} disabled={uploadFileInProgress} />
            <label className={css.addImageLabel} htmlFor={'files'}>
              <div className={classNames(css.secondaryButton)}>
                {uploadFileInProgress ? (
                  <IconSpinner rootClassName={css.uploadButtonSpinner} />
                ) : (
                  <>
                    <IconUploadFile />
                    <FormattedMessage id="SendMessageForm.uploadFile" />
                  </>
                )}
              </div>
            </label>

            {isArchive && (
              <p className={css.tip}>
                <FormattedMessage id="SendMessageForm.filesArchiveTip" />
                <br />
                <FormattedMessage id="SendMessageForm.supportedFormatsTip" />
              </p>
            )}

            {deleteOldFilesAfterUpload && (
              <p className={css.tip}>
                <FormattedMessage id="SendMessageForm.uploadOverridesTip" />
              </p>
            )}

            {validationError && <p className={css.error}>{validationError}</p>}
          </div>
        );
      }}
    </Field>
  );
};

FieldFileUploader.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(FieldFileUploader);
